<template>
<div ref="pop" v-show="show" :style="'z-index: '+z_index+';'">
	<div v-if="always_exist" v-show="show" v-click-outside="outsideClick" @click="clickClose">
        <slot></slot>
    </div>
    <div v-else-if="show" v-click-outside="outsideClick" @click="clickClose">
        <slot></slot>
    </div>
    <slot name="arrow"></slot>
</div>
</template>

<script>
import {
    createPopper
} from '@popperjs/core';

export default {

    data() {
        return {
            show: false,
            popper: {},
			saved_target: null
        }
    },
    props: {
        target_id: '',
        custom_target:null,
        append_to_body: {
            type: Boolean,
            default: false
        },
        close_on_click_outside: {
            type: Boolean,
            default: true
        },
        stay_open_on_click: {
            type: Boolean,
            default: false
        },
        placement: {
            type: String,
            default: 'bottom-start',
            required: false
        },
        match_width: {
            type: Boolean,
            default: false
        },
        strategy: {
            type: String,
            default: 'absolute',
            required: false
        },
        offset: {
            type: Array,
            default () {
                return [0, 0]
            }
        },
        arrow_padding: {
            type: Number,
            default: 0,
            required: false,
        },
		always_exist: {
			type: Boolean,
            default: false
		},
		prevent_overflow: {
			type: Boolean,
            default: true
		},
		allow_flip: {
			type: Boolean,
			default: true,
		},
		flip_options: {
			type: Object,
			default(){
				return {};
			},
		},
		z_index : {
			type: Number,
			default: 2000
		}
    },
    mounted() {
        var temp = this;
        var target = document.getElementById(this.target_id);

        if(this.custom_target){
        	target = this.custom_target
        }
		this.saved_target = target;
        //console.log("Popper Target", target)
        if (this.append_to_body) {
            document.body.appendChild(temp.$refs["pop"]);
        }

        this.$nextTick(function () {

            this.popper = createPopper(target, temp.$refs["pop"], {
                placement: temp.placement,
                strategy: temp.strategy,

                modifiers: [{
                        name: 'preventOverflow',
                        options: {
                            rootBoundary: 'document',
							mainAxis: this.prevent_overflow,
							altAxis: this.prevent_overflow,
                        },

                    },
					{
						name: "flip",
						enabled: this.allow_flip,
						options: {...this.flip_options}
					},
                    {
                        name: 'setPopperWidth',
                        enabled: true,
                        phase: "beforeWrite",
                        fn: this.setWidth, // (the function defined before)

                    },
                    {
                        name: 'offset',
                        options: {
                            offset: this.offset,
                        },
                    },
                    {
                        name: 'eventListeners',
                        enabled: false
                    },
                    {
                        name: 'arrow',
                        options: {
                            padding: this.arrow_padding, // 5px from the edges of the popper
                        },
                    }
                ],

            });
        });
    },

    beforeDestroy() {
        if (this.append_to_body) {
            document.body.removeChild(this.$refs["pop"]);
        }
    },

    methods: {
        toggle() {
            if (this.show) {
                this.close();
            } else {
                this.open();
            }
        },

        clickClose() {
            if (this.stay_open_on_click) {
                return
            }
            this.close();
        },
        outsideClick() {
            if (this.close_on_click_outside&&this.show) {
                this.close();
            }
        },
        close() {
            this.turnOff();
        },
        open() {
            //using setTimeout instead of nextTick
            //https://stackoverflow.com/questions/47634258/what-is-nexttick-or-what-does-it-do-in-vuejs
            //if we use nextTick we have issues with v-on-click-outside
            //when closing a popper and opening another at the same time
            //nexTick: called after update to DOM but before browser render
            //setTimeout: called after browser render
            var temp = this;
            setTimeout(function () {
                temp.turnOn();
            }, 0);

        },
        setWidth({
            state
        }) {
            // box-sizing: border-box
            if (this.match_width) {
                state.styles.popper.width = `${state.rects.reference.width}px`;
            }
        },
        turnOn() {

            this.show = true;
            this.popper.setOptions({
                placement: this.placement,
                strategy: this.strategy,

                modifiers: [{
                        name: 'preventOverflow',
                        options: {
                            rootBoundary: 'document',
							mainAxis: this.prevent_overflow,
                        },
                    },
					{
						name: "flip",
						enabled: this.allow_flip,
						options: {...this.flip_options}
					},
                    {
                        name: 'setPopperWidth',
                        enabled: true,
                        phase: "beforeWrite",
                        fn: this.setWidth, // (the function defined before)
                    },
                    {
                        name: 'offset',
                        options: {
                            offset: this.offset,
                        },
                    },
                    {
                        name: 'eventListeners',
                        enabled: true
                    },
                    {
                        name: 'arrow',
                        options: {
                            padding: this.arrow_padding, // 5px from the edges of the popper
                        },
                    }
                ],
            })

        },
        turnOff() {
            this.show = false;
            this.popper.setOptions({
                placement: this.placement,
                strategy: this.strategy,

                modifiers: [{
                        name: 'preventOverflow',
                        options: {
                            rootBoundary: 'document',
							mainAxis: this.prevent_overflow,
                        },
                    },
					{
						name: "flip",
						enabled: this.allow_flip,
						options: {...this.flip_options}
					},
                    {
                        name: 'setPopperWidth',
                        enabled: true,
                        phase: "beforeWrite",
                        fn: this.setWidth, // (the function defined before)
                    },
                    {
                        name: 'offset',
                        options: {
                            offset: this.offset,
                        },
                    },
                    {
                        name: 'eventListeners',
                        enabled: false
                    },
                    {
                        name: 'arrow',
                        options: {
                            padding: this.arrow_padding, // 5px from the edges of the popper
                        },
                    }
                ],
            })

        }
    },
}
</script>
